import { Text } from '@mntn/ui-components'
import type { SortState, ViewMode } from '@/components/dashboard/dashboard'
import { useAdvertiserAccess } from '@/flight-deck-api/services/advertisers.service'
import type { OrderItemsStatusFilter } from '@/flight-deck-api/services/order-items.service'
import { useOrderItemsSummary } from '@/hooks'
import { useAuthenticatedSession } from '@/providers/session'
import { FilterTriggerButton } from '../filter-panel'
import { Search } from './search'
import { SortFieldDropdown } from './sort-field-dropdown'
import { StatusDropdown } from './status-dropdown'
import { StoreButton } from './store-button'
import { ToggleView } from './toggle-view'

interface ActionBarProps {
  status: OrderItemsStatusFilter
  setStatus: (status: OrderItemsStatusFilter) => void
  search: string
  setSearch: (search: string) => void
  sortState: SortState
  setSortState: (sortState: SortState) => void
  view: ViewMode
  setView: (view: ViewMode) => void
}

// biome-ignore lint/plugin: RETIRED, do not copy. Convert to a named function export when touching this.
export const ActionBar: React.FC<ActionBarProps> = ({
  status,
  setStatus,
  search,
  setSearch,
  sortState,
  setSortState,
  view,
  setView,
}) => {
  const { session } = useAuthenticatedSession()
  const advertiserId = session.advertiser.id
  const { data: advertiserAccess } = useAdvertiserAccess(advertiserId)
  const { statusSummary } = useOrderItemsSummary({
    status,
    search,
  })
  const hasStorefrontAccess = advertiserAccess.data.storefront

  // @note filter included as part of enhancement, additional work needed to ensure we display correct networks and genres
  const showFilter = false

  return (
    <div className="flex flex-wrap gap-4 justify-between items-center p-6 w-full">
      <Text className="text-header-inverse">FLIGHT DECK</Text>
      <div className="flex flex-1 flex-wrap flex-row gap-4 justify-end">
        <Search setSearchValue={setSearch} searchValue={search} placeholder="Search list by keyword..." />
        <div className="flex items-center gap-2 flex-wrap">
          <ToggleView view={view} setView={setView} />
          <StatusDropdown status={status} setStatus={setStatus} statusSummary={statusSummary} />
          <SortFieldDropdown sortState={sortState} setSortState={setSortState} search={search} />
          {hasStorefrontAccess && <StoreButton />}
          {showFilter && <FilterTriggerButton />}
        </div>
      </div>
    </div>
  )
}
